export abstract class TokenStorage {
  abstract getItem(name: string): string;
  abstract setItem(name: string, value: string): void;
  abstract removeItem(name: string): void;
  abstract clear(): void;
}
